import firebase from 'firebase/app'
import 'firebase/firestore'

const firebaseConfig = {
    apiKey: "AIzaSyA7DqsSq-DWw9XhxBygpsmnGHhM3prDzM0",
    authDomain: "accountit-app.firebaseapp.com",
    databaseURL: "https://accountit-app.firebaseio.com",
    projectId: "accountit-app",
    storageBucket: "accountit-app.appspot.com",
    messagingSenderId: "494729564527",
    appId: "1:494729564527:web:d284e7b8b0cd43eec2989a",
    measurementId: "G-E41NXYLT5S"
  };

export const db = firebase
    .initializeApp(firebaseConfig)
    .firestore();

firebase.firestore().enablePersistence().catch(function(err) {
    if (err.code == 'failed-precondition') {
        console.error('Firebase persistence init failed - multiple tabs'); //eslint-disable-line
    } else if (err.code == 'unimplemented') {
        console.error('Firebase persistence init failed - unsupported device'); //eslint-disable-line
    }
});

const { Timestamp, GeoPoint, FieldValue } = firebase.firestore
export { Timestamp, GeoPoint, FieldValue }
